/* global $, query_string, leaderboard_data, show_bat_tracking */
import Table from 'bam-node-savant-table/table-shim.ts'
import * as d3 from 'd3'

import setupApp from './percentile-ranking-filter-app.tsx'
import { EDIT_FILTERS_EVENT } from './percentile-ranking/FilterApp.tsx'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'prLeaderboard'

$('#btnUpdate').click(() => {
    window.location.href = `/leaderboard/percentile-rankings?type=${$(
        '#ddlType'
    ).val()}&year=${$('#ddlSeason').val()}&team=${$('#ddlTeamId').val()}`
})

$('#btnCSV').click(() => {
    window.location.href = `/leaderboard/percentile-rankings?type=${$(
        '#ddlType'
    ).val()}&year=${$('#ddlSeason').val()}&team=${$(
        '#ddlTeamId'
    ).val()}&csv=true`
})

$('#btnAddFilters').click((e) => {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent(EDIT_FILTERS_EVENT))
})

$('form').submit(false)

if (query_string.type) {
    if (query_string.type.indexOf('team') > -1) {
        $('#team-ddl').hide()
    }
    $('#ddlType').val(query_string.type).attr('selected', true)
}

if (query_string.year) {
    $('#ddlSeason').val(query_string.year).attr('selected', true)
}

if (query_string.team) {
    $('#ddlTeamId').val(query_string.team).attr('selected', true)
}
if (query_string.sortDir) {
    $('#sortDir').val(query_string.sortDir)
}

if (query_string.sort) {
    $('#sort').val(query_string.sort)
}

if ($('#ddlType').val() === 'batter') {
    $('#positionGroup').show()
}

const highlight = [5, 45, 55, 95]
const highlightColors = ['#3661AD', '#b4cfd1', '#b4cfd1', '#D82129']

let headers = [
    {
        name: 'Player',
        field: 'player_name',
        headerClass: 'th-component-header align-left table-static-column',
        fieldClass: 'tr-data align-left table-static-column',
        displayFn: (name, row) => {
            const playerId = row.player_id
            const season = $('#ddlSeason').val()
            const type = $('#ddlType').val()
            return `
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div>
                        <img 
                            class="player-mug"
                            onerror="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" 
                            src="https://midfield.mlbstatic.com/v1/people/${playerId}/mlb/60?circle=true"
                        >
                        <span>
                            <a href="/savant-player/${playerId}">${name}</a>
                        </span>
                    </div>

                    <a href="/comparison-tool?player=${playerId}-${season}-${type}&openSearch=true" target="_blank" style="margin-right: 5px;">
                        <img src="/site-core/images/comp_tool_icons27.png" width="24" height="24" />
                    </a>
                </div>
                `
        },
    },
    {
        name: 'xwOBA',
        field: 'percent_rank_xwoba',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'xBA',
        field: 'percent_rank_xba',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'xSLG',
        field: 'percent_rank_xslg',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'xISO',
        field: 'percent_rank_xiso',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'xOBP',
        field: 'percent_rank_xobp',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },

    {
        name: 'Brl',
        field: 'percent_rank_barrel',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'Brl%',
        field: 'percent_rank_barrel_batted_rate',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'EV',
        field: 'percent_rank_exit_velocity_avg',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'Max EV',
        field: 'percent_rank_exit_velocity_max',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'HardHit%',
        field: 'percent_rank_hard_hit_percent',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'K%',
        field: 'percent_rank_k_percent',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'BB%',
        field: 'percent_rank_bb_percent',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'Whiff%',
        field: 'percent_rank_whiff_percent',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
    {
        name: 'Chase%',
        field: 'percent_rank_chase_percent',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    },
]

if ($('#ddlType').val().indexOf('batter') > -1) {
    headers.push({
        name: 'Sprint<br/>Speed',
        field: 'percent_speed_order',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })

    headers.push({
        name: 'OAA',
        field: 'percent_rank_oaa',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })
    headers.push({
        name: 'Arm <br/>Strength',
        field: 'percent_rank_arm_overall',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })
} else {
    headers.push({
        name: 'FB Vel.',
        field: 'percent_rank_fastball_velo',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })
    headers.push({
        name: 'FB Spin',
        field: 'percent_rank_fastball_spin',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })
    headers.push({
        name: 'Curve Spin',
        field: 'percent_rank_cu_spin',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })
    headers.push({
        name: 'Extension',
        field: 'percent_rank_fastball_extension',
        type: 'number',
        headerClass: 'th-component-header align-center',
        fieldClass: 'tr-data align-center',
        highlight,
        highlightColors,
    })

    headers = headers.filter(
        (d) => d.field !== 'percent_rank_exit_velocity_max'
    )
}

if (show_bat_tracking) {
    headers.push(
        {
            name: 'Bat<br/>Speed',
            field: 'percent_rank_swing_speed',
            type: 'number',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            highlight,
            highlightColors,
        },
        {
            name: 'Squared-up<br/>Rate',
            field: 'percent_rank_squared_up_swing',
            type: 'number',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            highlight,
            highlightColors,
        },
        {
            name: 'Swing<br/>Length',
            field: 'percent_rank_swing_length',
            type: 'number',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            highlight,
            highlightColors,
        }
    )
}

const width = $(`#${tableDivId}`).outerWidth()
let repeatHeaders = false
if (width <= 768) {
    repeatHeaders = 15
}

// Fix to handle old urls that are column based
let sortVal = $('#sort').val()
if (!Number.isNaN(Number(sortVal))) {
    sortVal =
        headers[Number(sortVal)].customSortField ||
        headers[Number(sortVal)].field
}

// eslint-disable-next-line no-new, new-cap
const table = new Table({
    id: 'prLeaderboard',
    repeatHeader: repeatHeaders,
    headers,
    defaultSort: sortVal,
    defaultSortDirection: $('#sortDir').val(),
    sortClass: 'column-sort',
    // PASS IN UNIQUE ROW ID... Use this for ajax calls
    subDataId: 'entity_id',
    showRank: true,
    data: leaderboard_data,
    highlightFalsy: false,
    highlightInterpolation: d3.interpolateLab,
    pagination: { enabled: true },
    sortCallback(column, _, { state }) {
        const url = new URL(window.location)
        url.searchParams.set('sort', column)
        url.searchParams.set('sortDir', state)
        window.history.replaceState('', '', url.toString())
    },
})

window.addEventListener('scroll', () => {
    if (!ticking && leaderboard_data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId)
            ticking = false
        })

        ticking = true
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const divWidth = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (divWidth && divWidth > 767) {
        // console.log(width);
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $('.default-table-row')
            .first()
            .children('td')
            .each(function handleEach() {
                const eachWidth = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    eachWidth
                )
                tableCell += 1
            })

        $(`#${divId} table thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $('.tr-component-row')
            .children('th')
            .each(function handleEach() {
                const eachWidth = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    eachWidth
                )
                tableCell += 1
            })
    }
}

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})

setupApp(table)
